import React, { FC, ReactNode, useState } from "react";
import { IconType } from "react-icons";
import classNames from "classnames";
import styles from "./Card.module.scss";

type CardProps = {
  id: string;
  header: string;
  children: ReactNode;
  image?: string | IconType;
  showClose?: boolean;
  width?: string;
  headerIcons?: ReactNode;
  customClassNames?: {
    card?: string;
    header?: string;
    body?: string;
  };
};

const Card: FC<CardProps> = ({
  id,
  header,
  children,
  image,
  showClose = false,
  headerIcons,
  width = "450px",
  customClassNames = {},
}) => {
  const [isOpen, setIsOpen] = useState(true);
  const IconComponent = image && typeof image !== "string" ? image : null;

  if (!isOpen) return null;

  const cardClassName = classNames(styles.card, customClassNames.card);
  const headerClassName = classNames(styles.header, customClassNames.header);
  const bodyClassName = classNames(styles.body, customClassNames.body);

  // @ts-ignore
  return (
    <div key={id} className={cardClassName} style={{ maxWidth: width }}>
      <div className={headerClassName}>
        {image && (
          <div className={styles["image-container"]}>
            {IconComponent ? (
              <IconComponent color={"#ff6347"} />
            ) : (
              <img
                src={image as string}
                alt="header"
                className={styles.imageSize}
              />
            )}
          </div>
        )}
        <div className={styles.title}>{header}</div>
        <div className={styles.headerIcons}>{headerIcons}</div>
        {showClose && (
          <div
            className={styles.buttonContainer}
            onClick={() => setIsOpen(false)}
          >
            X
          </div>
        )}
      </div>
      <div className={bodyClassName}>{children}</div>
    </div>
  );
};

export default Card;
